
import React, { memo, Suspense } from 'react';
import { useTabNavigation } from './contexts/tab-navigation';
import 'bootstrap/dist/css/bootstrap.min.css';

// Dışarıda tanımla: her re-render'da yeni component oluşturulmasın.
// Aksi halde sekme değişince React farklı component tipi görüp tüm içeriği unmount/mount eder → gereksiz API istekleri
const TabContentRenderer = memo(function TabContentRenderer({ component: Component }) {
  return Component ? (
    <Suspense fallback={<div style={{ padding: 24, color: '#666' }}>Yükleniyor…</div>}>
      {React.createElement(Component)}
    </Suspense>
  ) : null;
});

export default function BootstrapTabs() {
  const { tabs, activeTabIndex, setActiveTabIndex, closeTab } = useTabNavigation();

  if (tabs.length === 0) return null;

  const visibleTabs = tabs;
  const showWarning = false;

  return (
    <div className="container-fluid" style={{ height: '100%' }}>
      {showWarning && (
        <div className="alert alert-warning" style={{ margin: '8px 0' }}>
          En fazla 10 sekme görüntülenebilir. Kullanmadığınız sekmeleri kapatmanızı tavsiye ederiz.
        </div>
      )}
      <ul className="nav nav-tabs" role="tablist">
        {visibleTabs.map((tab, idx) => {
          const isLastCreated = idx === visibleTabs.length - 1;
          return (
          <li className="nav-item" key={tab.key}>
            <button
              className={`nav-link${activeTabIndex === idx ? ' active' : ''}`}
              style={isLastCreated ? {
                backgroundColor: '#28a745',
                color: '#000',
                borderColor: '#28a745',
                fontWeight: 600,
              } : undefined}
              onClick={() => setActiveTabIndex(idx)}
              type="button"
              role="tab"
            >
              {tab.title}
              <span
                style={{ marginLeft: 8, cursor: 'pointer', color: isLastCreated ? '#000' : '#888' }}
                onClick={e => {
                  e.stopPropagation();
                  closeTab(idx);
                }}
              >×</span>
            </button>
          </li>
          );
        })}
      </ul>
      <div className="tab-content" style={{ height: 'calc(100% - 40px)', position: 'relative', zIndex: 1 }}>
        {visibleTabs.map((tab, idx) => {
          const isActive = activeTabIndex === idx;
          return (
            <div
              key={tab.key}
              className={`tab-pane ${isActive ? 'show active' : ''}`}
              role="tabpanel"
              aria-hidden={!isActive}
              style={{
                height: '100%',
                display: isActive ? 'block' : 'none'
              }}
            >
              <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <TabContentRenderer component={tab.component} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
